interface FeaturePickerProps {
  selected: string[];
  onChange: (next: string[]) => void;
}

const FEATURE_OPTIONS = [
  { label: "Bluetooth audio", icon: "ri-bluetooth-line" },
  { label: "Air conditioning", icon: "ri-snowy-line" },
  { label: "Reverse camera", icon: "ri-camera-lens-line" },
  { label: "Parking sensors", icon: "ri-radar-line" },
  { label: "Sunroof", icon: "ri-sun-line" },
  { label: "Cruise control", icon: "ri-speed-up-line" },
  { label: "GPS navigation", icon: "ri-navigation-line" },
  { label: "USB charging", icon: "ri-usb-line" },
  { label: "Android Auto / CarPlay", icon: "ri-smartphone-line" },
  { label: "Child seat", icon: "ri-parent-line" },
  { label: "Roof rack", icon: "ri-luggage-cart-line" },
  { label: "Unlimited mileage", icon: "ri-road-map-line" },
];

export default function FeaturePicker({ selected, onChange }: FeaturePickerProps) {
  const toggle = (label: string) => {
    if (selected.includes(label)) {
      onChange(selected.filter((item) => item !== label));
    } else {
      onChange([...selected, label]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2.5">
      {FEATURE_OPTIONS.map((option) => {
        const active = selected.includes(option.label);
        return (
          <button
            key={option.label}
            type="button"
            onClick={() => toggle(option.label)}
            className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full border px-3.5 py-2 text-sm transition-colors ${
              active
                ? "border-primary-500 bg-primary-500/12 text-primary-300"
                : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-500/50"
            }`}
          >
            <i className={option.icon}></i> {option.label}
          </button>
        );
      })}
    </div>
  );
}